// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"204":"c82beaba","344":"79f83024","703":"bd526253","723":"7c91d454","843":"edbf364c","890":"637f4d59","954":"da226135"}[chunkId] + ".chunk.js";
};